import { render, staticRenderFns } from "./ChurnDescriptionPopupContent.vue?vue&type=template&id=2228e20e&scoped=true&"
import script from "./ChurnDescriptionPopupContent.vue?vue&type=script&lang=js&"
export * from "./ChurnDescriptionPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./ChurnDescriptionPopupContent.vue?vue&type=style&index=0&id=2228e20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228e20e",
  null
  
)

export default component.exports